// extracted by mini-css-extract-plugin
export default {"orderInfoValue":"CostCalculationTable_orderInfoValue__8SQMn","noPaddingEnds":"CostCalculationTable_noPaddingEnds__QLZgb","ccrLink":"CostCalculationTable_ccrLink__tG7mM"};